import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    root: {
        display: "flex",
        flexDirection: "column",
        height: "100%",
        minHeight: 0,
        boxShadow: "0px 2px 9px rgba(19, 61, 133, 0.15)",
        borderRadius: 10,
        overflow: "hidden",
    },
    carouselArea: {
        flex: 1,
        minHeight: 0,
        "& .CarouselItem": {
            height: "100%",
        },
    },
    slide: {
        height: "100%",
        overflow: "hidden",
        padding: `${theme.spacing(2)} ${theme.spacing(6)} 0 ${theme.spacing(6)}`,
        "@media (min-width: 1300px)": {
            paddingTop: theme.spacing(3),
        },
    },
}));
